import { null as null_, object, string } from "zod";

export const setMultipassSecret = {
  name: "setMultipassSecret" as const,
  input: object({ teamId: string(), secret: string() }),
  output: null_(),
};
